import { VStack as ChakraVStack } from '@chakra-ui/react';
import { ElementType } from 'react';
import { StackProps } from './stack.types';

export function VStack<T extends ElementType = 'div'>(props: StackProps<T>) {
  return <ChakraVStack {...props} />;
}